import { Stack } from '@mui/material';
import { Prompt } from '@server/prompts';
import {
  PromptWithArrow,
  PromptWithArrowActions,
} from '../common/ai-chat/input-atoms/PromptWithArrow';

interface AgentPromptsProps {
  prompts: Pick<Prompt, 'id' | 'name' | 'promptText'>[];
  onClickPrompt: (prompt: string) => Promise<void>;
  onActionClick?: (
    action: PromptWithArrowActions,
    prompt: Pick<Prompt, 'id' | 'name' | 'promptText'>,
  ) => void;
  isDisabled: boolean;
  promptVariant?: 'small' | 'large';
}

const AgentPrompts = ({
  prompts,
  onClickPrompt,
  onActionClick,
  isDisabled,
  promptVariant,
}: AgentPromptsProps) => {
  return (
    <Stack width="100%">
      {prompts.map((prompt) => (
        <PromptWithArrow
          key={prompt.name}
          onClick={() => onClickPrompt(prompt.promptText)}
          prompt={prompt}
          isDisabled={isDisabled}
          variant={promptVariant}
          onActionClick={onActionClick}
        />
      ))}
    </Stack>
  );
};

export default AgentPrompts;
